import {breakpoints, css} from 'quickstart/styled-components/system'

// Use -top and -bottom instead of short versions, so that this style can be
// combined with the container style at the global level for static pages.
const getSections = (theme: any) => ({
  default: css`
    ${breakpoints({
      xs: css`
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
      `,
      sm: css`
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      `,
      md: css`
        padding-top: 2rem;
        padding-bottom: 2rem;
      `,
      lg: css`
        padding-top: 3rem;
        padding-bottom: 3rem;
      `, // was 2.75rem with dividers
    })}
  `,
  skinny: css`
    ${breakpoints({
      xs: css`
        padding-top: 1rem;
        padding-bottom: 1rem;
      `,
      sm: css`
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
      `,
      md: css`
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      `,
      lg: css`
        padding-top: 2rem;
        padding-bottom: 2rem;
      `,
    })}
  `,
  superskinny: css`
    ${breakpoints({
      xs: css`
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      `,
      sm: css`
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
      `,
      md: css`
        padding-top: 1rem;
        padding-bottom: 1rem;
      `,
      lg: css`
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
      `,
    })}
  `,
  abutting: css`
    ${breakpoints({
      xs: css`
        padding-top: 0;
        padding-bottom: 0;
      `,
    })}
  `,
})

export default getSections
